export default __webpack_public_path__ + "static/media/inspector.a5bca9bc.jpg";